module.exports = __webpack_public_path__ + "img/6.d57263a7.jpg";